import React, { useState } from "react";
import { View, Text, Image } from "@react-pdf/renderer";
import { buildCloudinaryImageUrl } from "../../../../utils/CloudinaryImageUrl";
import img_default from "../../../../assets/img/default.png";
const money = (n) => Number(n).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export default function ItemsTable({ S, items }) {

  const vreTotalTaxes = (taxes) => {
    console.log("Taxes pdf Products", taxes);
    if (Array.isArray(taxes)) {
      const total = taxes.reduce((acc, t) => acc + Number(t.total || t), 0);
      return total;
    }
  }

  return (
    <View style={S.table}>
      <View style={S.thead}>
        <Text style={[S.th, S.cNo]}>No.</Text>
        <Text style={[S.th, S.cImg]}> Imagen </Text>
        <Text style={[S.th, S.cDesc]}>Descripción</Text>
        <Text style={[S.th, S.cQty]}>Cantidad</Text>
        <Text style={[S.th, S.cPU]}>Precio Unitario</Text>
        <Text style={[S.th, S.cDU]}>Descuento Unitario</Text>
        <Text style={[S.th, S.cItbms]}>Subtotal</Text>
        <Text style={[S.th, S.cItem]}>Total Item</Text>
      </View>

      {items.map((it, idx) => (
        <React.Fragment key={idx}>
          <View>
            <View style={S.tr}>
              <Text style={[S.td, S.cNo]}>{idx + 1}</Text>
              <View style={[S.td, S.cImg]}>
                <View style={S.imageContainerTable}>
                  <Image
                    src={buildCloudinaryImageUrl({ url: it.img, width: 300, quality: "auto", type: "image" }) || img_default}
                    style={S.imageFitTable}
                  />
                </View>
              </View>
              <Text style={[S.td, S.cDesc]}>{it.name}</Text>
              <Text style={[S.td, S.cQty]}>{it.amount}</Text>
              <Text style={[S.td, S.cPU]}>{money(it.price)}</Text>
              <Text style={[S.td, S.cDU]}>{money(it.unit_discount)}</Text>
              <Text style={[S.td, S.cItbms]}>{money((it.amount * it.price))}</Text>
              <Text style={[S.td, S.cItem]}>{money((it.amount * it.price) - it.discount)}</Text>
            </View>
            {it.note && (
              <View style={{ flexDirection: 'row', marginLeft: 8, marginBottom: 2 }}>
                <Text style={{ fontSize: 9, color: '#1976d2', fontWeight: 'bold', marginRight: 4 }}>Nota:</Text>
                <Text style={{ fontSize: 9, color: '#555' }}>{it.note}</Text>
              </View>
            )}
            {/* Línea divisoria después de la nota */}
            <View style={{ borderBottomWidth: 1, borderBottomColor: '#e0e0e0', marginVertical: 2 }} />
          </View>
        </React.Fragment>
      ))}
    </View>
  );
}